// extracted by mini-css-extract-plugin
export var alert = "OXeW1rTL_uF8vzkoChLK";
export var journeyTrack = "DkALqQz5S9BZsGtSQN6t";
export var paddedContent = "vHCydz1BXHnvdAAMrVQF";